import { Entity, JoinColumn, ManyToOne } from 'typeorm'
import { UserModifiableEntity } from '../entity'
import { User } from '../user'
import { Table } from './table.model'

@Entity()
export class TableSubscriber extends UserModifiableEntity<TableSubscriber> {
	@ManyToOne(() => Table, { nullable: false })
	@JoinColumn()
	table: Table

	@ManyToOne(() => User, { nullable: false })
	@JoinColumn()
	user: User
}
